import { officeCategoryConstants as C } from '../actions/constants';

const initial = {
    available: [],
    mine: [],
    office: [],
    loading: false,
    error: null,
    message: null,
};

export default function officeCategory(state = initial, action) {
    switch (action.type) {
        case C.LIST_AVAILABLE_REQUEST:
        case C.LIST_MINE_REQUEST:
        case C.LIST_OWNED_REQUEST:
        case C.CREATE_REQUEST:
        case C.UPDATE_REQUEST:
        case C.DELETE_REQUEST:
        case C.SHARE_REQUEST:
            return { ...state, loading: true, error: null };

        case C.LIST_AVAILABLE_SUCCESS:
            return { ...state, loading: false, available: action.payload };
        case C.LIST_MINE_SUCCESS:
            return { ...state, loading: false, mine: action.payload };
        case C.LIST_OWNED_SUCCESS:
            return { ...state, loading: false, office: action.payload };

        case C.CREATE_SUCCESS:
        case C.UPDATE_SUCCESS:
        case C.DELETE_SUCCESS:
        case C.SHARE_SUCCESS:
            return { ...state, loading: false, message: 'OK' };

        case C.LIST_AVAILABLE_FAILURE:
        case C.LIST_MINE_FAILURE:
        case C.LIST_OWNED_FAILURE:
        case C.CREATE_FAILURE:
        case C.UPDATE_FAILURE:
        case C.DELETE_FAILURE:
        case C.SHARE_FAILURE:
            return { ...state, loading: false, error: action.payload || 'Ошибка' };

        default:
            return state;
    }
}
